import React, { useEffect, useState } from "react"
import { Card, Col, Container, Form, Row } from "reactstrap"
import { useNavigate, useParams } from "react-router-dom"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Swal from "sweetalert2"
import axios from "axios"
import configure from "configure"
import Select from "react-select"
import {
  serviceOption,
} from "utils/common-options"
import Dropzone from "react-dropzone"
import { formatBytes } from "utils/common-helpers"
import { Switch } from "antd"
import { fetchNodeData } from "utils/common-fetchData"
import Loader from "pages/Separate/Loader"
import { useSelector } from "react-redux"

const EditCasestudy = () => {
  const navigate = useNavigate()
  const generalLocation = useSelector(state => state?.location?.locations)
  const [fixButtons, setFixButtons] = useState(false)
  const [isLoading, setLoading] = useState(false)

  const [ProjectName, setProjectName] = useState("")
  const [Service, setService] = useState("")
  const [Technology, setTechnology] = useState("")
  const [ProjectOverview, setProjectOverview] = useState("")
  const [Problem, setProblem] = useState("")
  const [Strategy, setStrategy] = useState("")
  const [Results, setResults] = useState([""])
  const [Testimonial, setTestimonial] = useState("")
  const [ProjectSImages, setSProjectImages] = useState([])
  const [ProjectImages, setProjectImages] = useState([])
  const [TestimonialImages, setTestimonialImages] = useState([])
  const [location, setlocation] = useState("")
  const [Website, setWebsite] = useState("")
  const [Ctype, setctype] = useState(false)
  const [Cemail, setcemail] = useState("")
  const [Cpassword, setCpassword] = useState("")
  const [techOptions, setTechOption] = useState([])
  const [error, setError] = useState({})
  const [websiteLogo, setWebsiteLogo] = useState('')

  const addResultField = () => {
    setResults(prev => [...prev, ""])
  }

  // Update specific result by index
  const updateResult = (index, value) => {
    const updated = [...Results]
    updated[index] = value
    setResults(updated)
  }

  // Remove specific result input
  const removeResultField = index => {
    const updated = Results.filter((_, i) => i !== index)
    setResults(updated)
  }

  const toggleLoading = (loading) => {
    setLoading(loading);
  }

  const { id } = useParams()

  useEffect(() => {
    fetchData()
  }, [])

  async function fetchData() {
    setLoading(true)
    axios
      .get(`${configure.nodeApi}/case-study/${id}`)
      .then(async res => {
        setLoading(false)
        setProjectName(res?.data?.caseStudy?.project_name)
        setlocation(
          generalLocation.find(
            item => item.value == res?.data?.caseStudy?.location
          )
        )
        setService(
          serviceOption.find(
            item => item.value == res?.data?.caseStudy?.services
          )
        )
        setWebsite(res?.data?.caseStudy?.website)
        if (
          res?.data?.caseStudy?.credential_email ||
          res?.data?.caseStudy?.credential_password
        ) {
          setctype(true)
        }
        setcemail(res?.data?.caseStudy?.credential_email)
        setCpassword(res?.data?.caseStudy?.credential_password)
        setProjectOverview(res?.data?.caseStudy?.project_overview)
        setProblem(res?.data?.caseStudy?.problem_information)
        setStrategy(res?.data?.caseStudy?.strategy_and_approach)
        setResults(JSON.parse(res?.data?.caseStudy?.achieved_results))
        const imagePaths = JSON.parse(res?.data?.caseStudy?.project_image); // from DB
        const existing = imagePaths?.map((url, i) => ({
          id: `existing-${i}`,
          preview: `${configure.nodeImgApi}/${url}`,
          isExisting: true,
        }));

        setSProjectImages(existing);
        // setProjectImages(existing)
        async function loadExistingImages() {
          const imageUrls = JSON.parse(res?.data?.caseStudy?.project_image) || [];

          const files = await Promise.all(imageUrls.map(async (url) => {
            try {
              const response = await fetch(`${configure.nodeImgApi}/${url}`, { mode: 'cors' });

              const contentType = response.headers.get("Content-Type") || "";
              if (!contentType.startsWith("image/")) {
                console.warn("Skipping non-image URL:", url, contentType);
                return null;
              }

              const blob = await response.blob();
              const filename = url.split('/').pop().split('?')[0];

              const file = new File([blob], filename, {
                type: blob.type || contentType,
                lastModified: Date.now()
              });

              // Attach preview & other meta
              Object.assign(file, {
                path: filename,
                preview: URL.createObjectURL(file),
                formattedSize: formatBytes(file.size)
              });

              return file;
            } catch (err) {
              console.error("Error fetching image", url, err);
              return null;
            }
          }));
          const validFiles = files.filter(Boolean);
          setProjectImages(validFiles);
        }

        loadExistingImages();
        setTestimonial(res?.data?.caseStudy?.testimonial)
        const response = await fetchNodeData(toggleLoading, 'portfolio-technologies');
        if (response?.success) {
          const options = response?.data?.map((obj) => ({
            value: obj?.id,
            label: obj?.name
          }))
          setTechOption(options)
          const optionIds = res?.data?.caseStudy?.technology
          const resultDay = options?.filter(opt =>
            optionIds?.includes(opt.value)
          )
          setTechnology(resultDay)
        }
      })
      .catch(e => {
        setLoading(false)
      })
  }

  const saveCaseStudy = async e => {
    e.preventDefault()

    const validationErrors = {}
    if (!ProjectName.trim())
      validationErrors.ProjectName = "Project Name is required"
    if (!Website.trim()) validationErrors.Website = "Website URL is required"
    if (!location.value) validationErrors.location = "Location is required"
    if (!Service.value) validationErrors.Service = "Service is required"
    if (Technology.length == 0)
      validationErrors.Technology = "Technology is required"
    if (!ProjectOverview.trim())
      validationErrors.ProjectOverview = "Project Overview is required"
    if (!Problem.trim()) validationErrors.Problem = "Problem is required"
    if (!Strategy.trim()) validationErrors.Strategy = "Strategy is required"
    if (!Results.length || Results.some(r => !r.trim()))
      validationErrors.Results = "All Achieved Results must be filled"
    // if (!Testimonial.trim())
    //   validationErrors.Testimonial = "Testimonial is required"

    if (Object.keys(validationErrors).length > 0) {
      setError(validationErrors)
      return
    }

    setError({})
    setLoading(true)

    const formdata = new FormData()
    formdata.append("location", location?.value)
    formdata.append("website", Website)
    formdata.append("project_name", ProjectName)
    formdata.append("services", Service?.value)
    formdata.append("technology", Technology?.map((obj) => obj?.value))
    formdata.append("project_overview", ProjectOverview)
    formdata.append("problem_information", Problem)
    formdata.append("strategy_and_approach", Strategy)
    formdata.append("achieved_results", JSON.stringify(Results))
    formdata.append("testimonial", Testimonial)
    formdata.append("websiteLogo", websiteLogo)
    ProjectImages.forEach(file => {
      formdata.append("project_image", file)
    })
    // TestimonialImages.forEach(file => {
    //   formdata.append("testimonial_image", file)
    // })
    if (Ctype) {
      formdata.append("credential_email", Cemail)
      formdata.append("credential_password", Cpassword)
    }

    try {
      const res = await axios.put(
        `${configure.nodeApi}/case-study/${id}`,
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      if (res?.data?.success) {
        setLoading(false)
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Case Study Updated successfully!",
          confirmButtonColor: "#556ee6",
        }).then(() => {
          navigate(`${configure.appUrl}case-study`)
        })
      }
    } catch (e) {
      setLoading(false)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something Went Wrong",
      })
    }
  }

  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixButtons(true)
    } else {
      setFixButtons(false)
    }
  })

  // function handleAcceptedFiles1(files) {
  //   const updatedFiles = files.map(file => ({
  //     ...file,
  //     preview: URL.createObjectURL(file),
  //     formattedSize: formatBytes(file.size),
  //   }));

  //   // Merge newly accepted files with existing selected files
  //   setSProjectImages(prevFiles => [...prevFiles, ...updatedFiles])
  //   setProjectImages(prevFiles => [...prevFiles, ...updatedFiles]);
  // }

  function handleAcceptedFiles1(files) {
    const fill = files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    setProjectImages(prev => [...prev, ...fill]);

    const previews = files.map(file => ({
      preview: URL.createObjectURL(file),
    }));
    setSProjectImages(prev => [...prev, ...previews]);
  }

  const onRemoveImage = (index) => {
    const updated = ProjectSImages?.filter((obj, i) => index != i)
    setProjectImages(updated)
    setSProjectImages(updated)
  }

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content mb-3">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Edit Case Study"} />
          <Row className="px-1">
            <Form onSubmit={saveCaseStudy}>
              <div
                className={`flex-column fixed-buttons pt-2 ${fixButtons ? "d-flex" : "d-none"
                  }`}
              >
                <button
                  type="submit"
                  className="btn btn-save fix-btn btn-label pe-0"
                >
                  <i className="fas fa-save me-2 label-icon"></i>
                  <span>Save</span>
                </button>
                <a
                  onClick={() => navigate(-1)}
                  className="btn btn-red  fix-btn  btn-label pe-0"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  <span>Cancel</span>
                </a>
              </div>
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="col-md-6 mb-3">
                  <h5 className="mb-3">Case Study Information</h5>
                </div>
                <div className="col-md-6 mb-3 text-end">
                  <button
                    type="submit"
                    className=" btn ms-md-2 btn-save  btn-label"
                  >
                    <i className="fas fa-save me-1 label-icon"></i> save
                  </button>
                  <a
                    onClick={e => {
                      navigate(-1)
                    }}
                    className=" btn ms-md-2 btn-red  btn-label "
                  >
                    <i className="dripicons-cross me-2 icon-center label-icon"></i>
                    CANCEL
                  </a>
                </div>
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label>
                      Location <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="border-radius select"
                      placeholder="Select Location"
                      value={location}
                      onChange={e => setlocation(e)}
                      options={generalLocation}
                    ></Select>
                    {error.location && (
                      <span className="text-danger">{error.location}</span>
                    )}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label>
                      Services <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="border-radius select"
                      placeholder="Select Services"
                      value={Service}
                      onChange={e => setService(e)}
                      options={serviceOption}
                    ></Select>
                    {error.Service && (
                      <span className="text-danger">{error.Service}</span>
                    )}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label>
                      Technology <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="border-radius select"
                      placeholder="Select Technology"
                      isMulti
                      value={Technology}
                      onChange={e => setTechnology(e)}
                      options={techOptions}
                    ></Select>
                    {error.Technology && (
                      <span className="text-danger">{error.Technology}</span>
                    )}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label>
                      Project Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      placeholder="Enter Project Name"
                      value={ProjectName}
                      onChange={e => setProjectName(e.target.value)}
                    />
                    {error.ProjectName && (
                      <span className="text-danger">{error.ProjectName}</span>
                    )}
                  </div>

                  <div className="col-md-4 mb-3">
                    <label>
                      Website <span className="text-danger">*</span>
                    </label>
                    <input
                      value={Website}
                      onChange={e => setWebsite(e.target.value)}
                      type="text"
                      className="form-control"
                      placeholder="Enter Website"
                    ></input>
                    {error.Website && (
                      <span className="text-danger">{error.Website}</span>
                    )}
                  </div>

                  <div className="col-4 mb-3">
                    <label>Website Logo</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={e => setWebsiteLogo(e.target.files[0])}
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label>
                      Credentials <span className="text-danger">*</span>
                    </label>
                    <div>
                      <Switch
                        defaultChecked={Ctype}
                        className="mt-1"
                        style={{ fontSize: "14px" }}
                        onChange={e => {
                          setctype(e)
                        }}
                      />
                    </div>
                  </div>


                  {Ctype && (
                    <>
                      <div className="col-md-4 mb-3">
                        <label>
                          Email <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          placeholder="Enter Credential Email"
                          value={Cemail}
                          onChange={e => setcemail(e.target.value)}
                        />
                      </div>

                      <div className="col-md-4 mb-3">
                        <label>
                          Password <span className="text-danger">*</span>
                        </label>
                        <input
                          value={Cpassword}
                          onChange={e => setCpassword(e.target.value)}
                          type="text"
                          className="form-control"
                          placeholder="Enter Credential Password"
                        ></input>
                      </div>
                    </>
                  )}
                </div>
              </Row>

              {/* Project Overview */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-4">Project Overview</h5>
                <div className="col-12 mb-3">
                  <CKEditor
                    editor={ClassicEditor}
                    data={ProjectOverview}
                    onChange={(event, editor) => {
                      setProjectOverview(editor.getData())
                    }}
                  />
                  {error.ProjectOverview && (
                    <span className="text-danger">{error.ProjectOverview}</span>
                  )}
                </div>
                <div className="col-6 mb-3">
                  <label>Project Images</label>
                  <Dropzone
                    onDrop={acceptedFiles => {
                      handleAcceptedFiles1(acceptedFiles)
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div
                        className="dz-message needsclick p-0"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div
                          className="d-flex px-2 custom-file-upload align-items-center"
                          style={{ cursor: "pointer" }}
                        >
                          <div className="">
                            <i className="display-6 text-muted bx bxs-cloud-upload" />
                          </div>
                          <h5 className="mb-0 ms-2">Upload Files</h5>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                </div>
                <div
                  className={`col-6 dropzone-previews ${ProjectImages.length > 0 ? "d-block" : "d-none"
                    }`}
                  id="file-previews"
                >
                  <label className="mb-1">Uploaded Files</label>
                  <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                    <div className="p-0">
                      <Row className="align-items-center ">
                        {ProjectSImages?.map((f, i) => {
                          return (
                            <Col key={i} className="col-auto">
                              <span className="text-danger " style={{ position: 'absolute', top: "-5px", right: "-8px" }}
                                onClick={() => onRemoveImage(i)}>
                                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                              </span>
                              <img
                                data-dz-thumbnail=""
                                height="80"
                                className="avatar-sm rounded bg-light"
                                alt={f.name}
                                src={f.preview}
                              />
                            </Col>
                          )
                        })}
                      </Row>
                    </div>
                  </Card>
                </div>
              </Row>

              {/* Problem */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-4">Problem Information</h5>
                <div className="col-12 mb-3">
                  <CKEditor
                    editor={ClassicEditor}
                    data={Problem}
                    onChange={(event, editor) => {
                      setProblem(editor.getData())
                    }}
                  />
                  {error.Problem && (
                    <span className="text-danger">{error.Problem}</span>
                  )}
                </div>
              </Row>

              {/* Strategy */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-4">Strategy & Approach</h5>
                <div className="col-12 mb-3">
                  <CKEditor
                    editor={ClassicEditor}
                    data={Strategy}
                    onChange={(event, editor) => {
                      setStrategy(editor.getData())
                    }}
                  />
                  {error.Strategy && (
                    <span className="text-danger">{error.Strategy}</span>
                  )}
                </div>
              </Row>

              {/* Results */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-4 d-flex justify-content-between align-items-center">
                  Achieved Results
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={addResultField}
                  >
                    + Add Result
                  </button>
                </h5>
                <div className="col-12">
                  {Results.map((result, index) => (
                    <div key={index} className="d-flex mb-2 align-items-center">
                      <input
                        type="text"
                        className="form-control me-2"
                        placeholder={`Result #${index + 1}`}
                        value={result}
                        onChange={e => updateResult(index, e.target.value)}
                      />
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => removeResultField(index)}
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                  {error.Results && (
                    <span className="text-danger">{error.Results}</span>
                  )}
                </div>
              </Row>

              {/* Testimonial */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-4">Testimonial</h5>
                <div className="col-12 mb-3">
                  <CKEditor
                    editor={ClassicEditor}
                    data={Testimonial}
                    onChange={(event, editor) => {
                      setTestimonial(editor.getData())
                    }}
                  />
                  {error.Testimonial && (
                    <span className="text-danger">{error.Testimonial}</span>
                  )}
                </div>
                <div className="col-12 mb-3">
                  <label>Testimonial Images</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={e =>
                      setTestimonialImages(Array.from(e.target.files))
                    }
                    multiple
                  />
                </div>
              </Row>
            </Form>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EditCasestudy
